module.exports = __webpack_public_path__ + "img/BiazfanxmamNRoxxVxka.fda3837f.png";